<div class="page-header">
    <div class="header-start">
        <h3 class="title">
            <ng-container *ngIf="title == 'view'">View User</ng-container>
            <ng-container *ngIf="title == 'edit'">Edit User</ng-container>
            <ng-container *ngIf="title != 'edit' && title != 'view'">Add User</ng-container>
        </h3>
    </div>
    <div class="header-end">

    </div>
</div>
<nav aria-label="breadcrumb">
    <ol class="breadcrumb">
        <li class="breadcrumb-item"><a class="link" style="cursor: pointer;" (click)="navigateToUsers()">Users</a></li>
        <li class="breadcrumb-item active"><span>{{title == 'edit'? 'Edit User': title == 'view'? 'View User':
                'Add User'}}</span></li>
    </ol>
</nav>
<div class="stepper-height">
    <spinner [id]="'user-config-usermgmt'" [show]='loading'></spinner>
<mat-stepper #stepper [selectedIndex]="currentTabIndex" color="primary" [linear]="operation != 'edit' && operation != 'view'" (selectionChange)="onToggleTab($event)">
    <!-- user details -->
    <mat-step  [stepControl]="userForm && primaryMobileForm">
        <ng-template matStepLabel>User Info</ng-template>
        <ng-template matStepContent>

        <form [formGroup]="userForm" autocomplete="off" class="mt-2">



            <div class="row g-3" *ngIf="userConfig">
                <ng-container *ngFor="let config of objectKeys(userConfig)">
                    <ng-container [ngSwitch]="config">
                        <ng-container *ngSwitchCase="'firstName'">
                            <div [class]="userConfig.config?.class || constants?.addUser?.firstName?.class">

                                <mat-form-field class="w-100" appearance="outline">
                                    <mat-label>{{userConfig.config?.title ||
                                        constants?.addUser?.firstName?.title}}</mat-label>
                                    <input matInput (keypress)="onlyAlphabet($event)" maxlength="25"
                                        formControlName="firstName"
                                        [placeholder]="userConfig.config?.firstName?.label || constants?.placeHolder?.firstName?.label"
                                        name="firstName">
                                </mat-form-field>



                            </div>
                        </ng-container>
                        <ng-container *ngSwitchCase="'lastName'">
                            <div [class]="userConfig.config?.class || constants?.addUser?.lastName?.class">
                                <mat-form-field class="w-100" appearance="outline">
                                    <mat-label>{{userConfig.config?.title ||
                                        constants?.addUser?.lastName?.title}}</mat-label>
                                    <input matInput (keypress)="onlyAlphabet($event)" maxlength="25"
                                        formControlName="lastName"
                                        [placeholder]="userConfig.config?.lastName?.label || constants?.placeHolder?.lastName?.label"
                                        name="lastName">
                                </mat-form-field>


                            </div>
                        </ng-container>
                        <ng-container *ngSwitchCase="'username'">
                            <div [class]="userConfig.config?.class || constants?.addUser?.username?.class">
                                <mat-form-field class="w-100" appearance="outline">
                                    <mat-label>{{userConfig.config?.title ||
                                        constants?.addUser?.username?.title}}</mat-label>
                                    <input matInput (keypress)="onlyLowerCaseAlphabet($event)" maxlength="25"
                                        formControlName="username"
                                        [placeholder]="userConfig.config?.username?.label || constants?.placeHolder?.userName?.label">
                                </mat-form-field>


                            </div>
                        </ng-container>
                        <ng-container *ngSwitchCase="'email'">
                            <form [class]="userConfig.config?.class || constants?.addUser?.email?.class" [formGroup]="userForm">
                                <mat-form-field class="w-100" [color]="userForm.get('email')?.touched && !isEmailValid ? 'warn' : 'primary'" appearance="outline">
                                    <mat-label>{{userConfig.config?.title ||
                                        constants?.addUser?.email?.title}}</mat-label>
                                    <input matInput formControlName="email" [disabled]="true"
                                        [placeholder]="userConfig.config?.email?.label || constants?.placeHolder?.email?.label"
                                        (input)="validateEmail($event)" required>
                                    <mat-hint class="text-danger" *ngIf="userForm.get('email')?.touched && !isEmailValid">Please enter a valid email</mat-hint>                                    
                                </mat-form-field>

                            </form>
                        </ng-container>
                        <div class="col-sm-6 col-lg-3" *ngSwitchCase="'mobileNo'">
                            <form #primaryMobileFormRef="ngForm" [formGroup]="primaryMobileForm">
                                <mat-form-field class="w-100" appearance="outline">
                                    <mat-label>{{userConfig.config?.title }} Phone Number</mat-label>
                                    <ngx-mat-intl-tel-input *ngIf="operation !== 'view'"  [enablePlaceholder]="true" [enableSearch]="true"
                                    [required]="true"
                                        [maxLength]="15" [phoneValidation]="true" [cssClass]="'custom'"
                                        [searchCountryFlag]="true" [preferredCountries]="['in','us', 'ca']"
                                        [enablePlaceholder]="true" name="primaryMobileNo"
                                        formControlName="primaryMobileNo" #phone (input)="checkLength($event)">
                                    </ngx-mat-intl-tel-input>
                                    <mat-hint class="text-danger" *ngIf="!isPrimaryMobileNoValid">*Invalid Phone Number</mat-hint>
                                    <input matInput *ngIf="operation === 'view'" readonly formControlName="primaryMobileNo" [value]="userDetails.primaryMobileNo">
                                </mat-form-field>
                            </form>
                        </div>
                        <ng-container *ngSwitchCase="'status'">
                            <div class="col-sm-6 col-lg-3">
                                <mat-label class="d-block">{{userConfig?.['status']?.title }}</mat-label>
                                <!-- <label for="">{{userConfig.config?.title}}</label> -->
                                <mat-radio-group aria-label="Select an option" formControlName="status" [disabled]="operation == 'view'">
                                    <mat-radio-button value="Active" ngDefaultControl name="status"
                                        id="active">{{userConfig?.['status']?.statusValues[0]}}</mat-radio-button>
                                    <mat-radio-button value="Inactive" ngDefaultControl name="status"
                                        id="inactive">{{userConfig?.['status']?.statusValues[1]}}</mat-radio-button>
                                </mat-radio-group>
                            </div>
                        </ng-container>
                    </ng-container>
                </ng-container>
                <ng-container *ngIf="!isCustomer && operation == 'new'">
                    <div class="col-sm-6 col-lg-3">
                        <mat-form-field class="w-100" appearance="outline">
                            <mat-label>Customers</mat-label>
                            <mat-select formControlName="customers" (selectionChange)="filterAndResetReportingToField($event)">
                                <mat-option (click)="userForm.controls['customers'].reset()">No Customer</mat-option>
                                <mat-option *ngFor="let cust of customerList" [value]="cust">
                                    {{cust['customerName']}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>

                    </div>
                </ng-container>
                <ng-container>
                    <div class="col-sm-6 col-lg-3">
                        <mat-form-field class="w-100" appearance="outline">
                            <mat-label>Reporting To</mat-label>
                            <mat-icon matIconSuffix *ngIf="userForm.controls['reportingToId']?.value" (click)="userForm.controls['reportingToId'].reset()">close</mat-icon>
                            <mat-select formControlName="reportingToId" searchable [isObjectsList]="true">
                                <mat-option *ngFor="let user of filteredUsersList" [value]="user.userId">
                                    {{user['firstName']}} {{user['lastName']}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </ng-container>
                <ng-container *ngIf="!isCustomer && operation != 'new'">
                    <div class="col-sm-6 col-lg-3">
                        <mat-form-field class="w-100" appearance="outline">
                            <mat-label>Customer</mat-label>
                            <input matInput *ngIf="operation == 'view'" readonly="true" [value]="customerName || '-'">
                            <input matInput *ngIf="operation != 'view'" readonly="true" [value]="customerName || '-'">
                        </mat-form-field>

                    </div>
                    <div class="col-sm-6 col-lg-3">
                        <mat-form-field class="w-100" appearance="outline">
                            <mat-label>Username</mat-label>
                            <input matInput readonly="true" [value]="userName || '-'" [disabled]="true">
                        </mat-form-field>

                    </div>
                </ng-container>
                <ng-container *ngIf="userMetaInfo && userMetaInfo['customerId'] && userMetaInfo['customerName']">
                    <div class="col-sm-6 col-lg-3">
                        <mat-form-field class="w-100" appearance="outline">
                            <mat-label>Customer</mat-label>
                            <input matInput readonly="true" [value]="userMetaInfo['customerName']">
                        </mat-form-field>
                    </div>
                    <div *ngIf = "operation == userConfigOperations.UPDATE_USER || operation == userConfigOperations.VIEW_USER" class="col-sm-6 col-lg-3">
                        <mat-form-field class="w-100" appearance="outline">
                            <mat-label>Username</mat-label>
                            <input matInput readonly="true" [value]="userName || '-'" [disabled]="true">
                        </mat-form-field>
                    </div>
                </ng-container>

                <!-- Extra fields section - only show if extraFields exist -->
                <ng-container *ngIf="hasExtraFields">
                    <ng-container formGroupName="extraFields" class="extra-fields">
                    <ng-container *ngFor="let field of customerExtraFields">
                        <div class="col-sm-6 col-lg-3">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>{{field.label | titlecase}}</mat-label>
                                <mat-select [formControlName]="field.control">
                                    <mat-option *ngFor="let value of extraFieldsJson?.customerExtraFieldsJson[field.control]" [value]="value">
                                        {{ value | titlecase}} 
                                    </mat-option>
                                </mat-select>
                        </mat-form-field>
                    </div>
                        
                    </ng-container>
                    </ng-container>
                </ng-container>
                
            </div>

            <div class="d-flex justify-content-end gap-2">
                <button mat-raised-button (click)="navigateToUsers()">{{constants?.addUser?.cancelBtn?.title}}</button>
                <button mat-raised-button color="primary" *ngIf="operation == 'new'"
                    [disabled]="userForm.invalid || !isEmailValid || primaryMobileForm.invalid"
                    (click)="handleAdd()">{{constants?.addUser?.addBtn?.title}}</button>
                <button mat-raised-button color="primary" *ngIf="operation == 'edit'" [disabled]="userForm.invalid"
                    (click)="handleUpdate()">Update</button>

            </div>

        </form>
        </ng-template>
    </mat-step>
    <!-- Assign role -->
    <mat-step label="Assign Role">
        <ng-template matStepLabel>Assign Role</ng-template>
        <ng-template matStepContent>

        <form [formGroup]="roleForm" autocomplete="off" >
            <div class="row g-3">
                <div class="col-sm-6 col-lg-3">
                    <ng-select class="p-0" name="roles" *ngIf="operation !== 'view'"
                        [items]="filteredRoles" [multiple]="false" [attr.disabled]="filteredRoles.length == 0"
                        bindLabel="roleName" [selectableGroupAsModel]="false" [closeOnSelect]="true" bindValue="roleId"
                        placeholder="Select Role" formControlName="newRole" groupBy="applicationName">
                        <ng-template ng-optgroup-tmp let-item="item">
                            {{item.applicationName || 'Other'}}
                        </ng-template>
                        <ng-template ng-option-tmp let-item="item" let-item$="item$">
                            <ng-container *ngIf="item$.selected else emptyCheck"><i class="far fa-check-square"></i>
                            </ng-container>
                            <ng-template #emptyCheck><i class="far fa-square"></i></ng-template>
                            &nbsp;{{item.roleName}}
                        </ng-template>
                        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                            <div class="ng-value" *ngFor="let item of items | slice:0:2">
                                <span class="ng-value-label">
                                    {{assertUserData(item).roleName}}</span>
                                <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                            </div>
                            <div class="ng-value" *ngIf="items.length > 2">
                                <span class="ng-value-label">{{items.length - 2}} more...</span>
                            </div>
                        </ng-template>
                    </ng-select>

                </div>

                <div class="mt-1">
                    <button mat-raised-button color="primary"  class="btn btn-primary h-100 px-4"
                        *ngIf="operation !== 'view' && roleForm.get('newRole')?.value" (click)="addRole()">Add
                        Role</button>
                </div>
            </div>


            <div class="form-group">
                <div class="row">
                    <div class="col-sm-6 col-lg-3">
                        <div class="user-info-item">
                            <div class="d-flex gap-3">

                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <ng-container formArrayName="scope">
                        <mat-error *ngIf="operation === 'view' && !hasRolesAssigned()">No role assigned</mat-error>
                        <div class="col-6 mb-3 user-info-item form-group"
                            *ngFor="let rolescope of scopeArray.controls; let i=index">
                            <ng-container [formGroupName]="i">
                                <div class="d-flex justify-content-between align-items-center mb-2 form-control"
                                    *ngIf="!roleRemoved">
                                    <p class="m-0">{{ getRoleNameAndApplicationName(i)}}</p>
                                    <div class="tdDataSize button-table d-flex gap-2" *ngIf="operation !== 'view'">
                                        <button (click)="removeScope(i)" [disabled]="operation === 'view'"
                                            class="btn btn-sm btn-link delete"><i class="bx bx-trash-alt"
                                                title="Delete"></i></button>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </ng-container>
                </div>
            </div>

            <div class="d-flex justify-content-end gap-2">
                <button mat-raised-button (click)="navigateToUsers()">Cancel</button>
                <button mat-raised-button color="primary" *ngIf="operation !== 'view'" [disabled]="roleForm.invalid"
                    (click)="handleUpdate()">{{title == 'add' ? 'Continue' : 'Update' }}</button>
            </div>
        </form>
    </ng-template>
    </mat-step>
    <!-- Assign scope -->
    <mat-step label="Assign Scope">
        <ng-template matStepLabel>Assign Scope</ng-template>
        <ng-template matStepContent>

        <form [formGroup]="roleForm" autocomplete="off">
            <div class="row">
                <ng-container formArrayName="scope">

                    <ng-container *ngFor="let rolescope of scopeArray.controls; let i=index">
                        <ng-container [formGroupName]="i">
                            <div class="my-2">
                            <h6 *ngIf="!roleRemoved">{{ getRoleName(i)}}</h6>
                            @if(getFiltersOfRole(i).length > 0){
                            <div class="d-flex gap-3">
                                <div class="col-md" *ngFor="let filter of getFiltersOfRole(i); let ind = index">
                                    <div *ngIf="filter.scopeType == 'NON_HIERARCHY'" class="form-group m-0">
                                            <lib-scope-extended *ngIf="filter.scopeName"
                                            [initialEntries]="rolescope.get(filter.scopeName)?.value ?? []"
                                            [userApplications]="userApplications"
                                            [userPermissionresourseList]="userPermissionresourseList"
                                            [applicationName]="getRoleName(i)"
                                            (entriesChange)="onEntriesChange($event,rolescope.get(filter.scopeName),rolescope,filter.scopeName)"
                                            (validEntries)="updateScopeValidity($event)"
                                            ></lib-scope-extended>
                                    </div>
                                    <div class="form-group m-0" *ngIf="filter.scopeType == 'HIERARCHY'">
                                        @if(filter.scopeName == 'application'){
                                            <mat-form-field appearance="outline" class="w-100">
                                                <mat-label>Application</mat-label>
                                                <mat-select
                                                  formControlName="application" 
                                                >
                                                  <mat-option
                                                    *ngFor="let app of userApplications"
                                                    [value]="app?.applicationId"
                                                  >
                                                    {{ app?.applicationName }}
                                                  </mat-option>
                                                </mat-select>
                                              </mat-form-field>

                                        }@else if(filter.scopeName == 'resource'){
                                            <mat-form-field appearance="outline" class="w-100">
                                                <mat-label>Resource</mat-label>
                                                <mat-select
                                                  formControlName="resource"
                                                  multiple >
                                                  <mat-option
                                                    *ngFor="let res of userPermissionresourseList['Mesa Dashboard']?.resources"
                                                    [value]="res.resourceName"
                                                  >
                                                    {{ res?.resourceName }}
                                                  </mat-option>
                                                </mat-select>
                                              </mat-form-field>
                                        }
                                    </div>
                                </div>

                            </div>
                        }@else {
                            <div>(* Selected role doesn't have any scope associated with it)</div>
                        }
                        </div>
                        </ng-container>
                    </ng-container>
                </ng-container>
            </div>
            <div class="d-flex justify-content-end gap-2 mt-4">
                <button mat-raised-button type="button"  (click)="navigateToUsers()">Cancel</button>
                 @if(checkScopeAvailable()){
                     <button mat-raised-button type="submit" color="primary" *ngIf="operation !== 'view'"
                         [disabled]="roleForm.invalid || !isScopeValid" (click)="handleUpdate()">Update</button>     
                 }
            </div>
        </form>
        </ng-template>
    </mat-step>
</mat-stepper>
</div>
